"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DINGTALK_USER_CONTACT_SYNCING = exports.DINGTALK_USER_NOT_EXIST = exports.DINGTALK_TENANT_NOT_EXIST = exports.DINGTALK_NOT_BIND_SPACE = exports.WECOM_NOT_BIND_SPACE = exports.FEISHU_ACCOUNT_NOT_BOUND = exports.USER_DEFINED_PASSWORD_ERR = exports.FORM_FOREIGN_DATASHEET_NOT_EXIST = exports.FORM_DATASHEET_NOT_EXIST = exports.LOG_OUT_UNSATISFIED = exports.PAYMENT_PLAN = exports.NOT_PERMISSION = exports.NODE_NOT_EXIST = exports.NODE_DELETED = exports.SPACE_LIMIT = exports.LINK_INVALID = exports.INVITER_SPACE_MEMBER_LIMIT = exports.SPACE_DELETED = exports.INVALID_SPACE = exports.BINDING_ACCOUNT_ERR = exports.MEMBER_NOT_EXIST = exports.COMMON_ERR = exports.FREQUENTLY_QR = exports.TEMPLATE_NOT_EXIST = exports.NODE_NUMBER_ERR = exports.SPACE_NOT_EXIST = exports.MOVE_FORM_SPACE = exports.BINDING_WECHAT = exports.NAME_AND_PWD_ERR = exports.PHONE_COMMON_ERR = exports.SMS_CODE_NOT_CHECK = exports.SMS_CHECK_ERR = exports.SMS_GET_ERR = exports.LOGIN_OUT_NUMBER = exports.PASSWORD_ERR = exports.EMAIL_ERR = exports.SAVE_RECONNECT_RUNING = exports.SAVE_ERROR_RUNING = exports.SAVE_TIMEOUT_RUNING = exports.SAVE_RUNING = exports.SAVE_ERROR = exports.TIME_OUT = exports.ACCOUNT_ERROR = exports.OPERATION_FREQUENT = exports.PHONE_VALIDATION = exports.SECONDARY_VALIDATION = exports.NVC_FAIL = exports.RESOURCE_NOT_EXIST = exports.UN_AUTHORIZED = exports.STATUS_OK = void 0;
exports.PasswordErr = exports.AccountErr = exports.PhoneErr = exports.SmsErrCode = exports.DELETE_ROLE_EXIST_MEMBER = exports.FRONT_VERSION_ERROR = exports.SPACE_CAPACITY_OVER_LIMIT = exports.WECOM_NOT_ADMIN = exports.WECOM_OUT_OF_RANGE = exports.WECOM_NO_INSTALL = exports.WECOM_NO_EXIST = exports.WECOM_HAS_BIND = exports.WECOM_NOT_BIND_DOMAIN = exports.WECOM_SHOP_USER_NOT_EXIST = void 0;
exports.STATUS_OK = 200;
exports.UN_AUTHORIZED = 201;
exports.RESOURCE_NOT_EXIST = 210;
exports.NVC_FAIL = 250;
exports.SECONDARY_VALIDATION = 251;
exports.PHONE_VALIDATION = 252;
exports.OPERATION_FREQUENT = 233;
exports.ACCOUNT_ERROR = 303;
exports.TIME_OUT = 303;
exports.SAVE_ERROR = 309;
exports.SAVE_RUNING = 300;
exports.SAVE_TIMEOUT_RUNING = 3001;
exports.SAVE_ERROR_RUNING = 3002;
exports.SAVE_RECONNECT_RUNING = 3003;
exports.EMAIL_ERR = 304;
exports.PASSWORD_ERR = 305;
exports.LOGIN_OUT_NUMBER = 306;
exports.SMS_GET_ERR = 230;
exports.SMS_CHECK_ERR = 231;
exports.SMS_CODE_NOT_CHECK = 232;
exports.PHONE_COMMON_ERR = 303;
exports.NAME_AND_PWD_ERR = 302;
exports.BINDING_WECHAT = 332; // The phone number has been bound to WeChat
exports.MOVE_FORM_SPACE = 403; // Moved out of space
exports.SPACE_NOT_EXIST = 404; // The invited space does not exist
exports.NODE_NUMBER_ERR = 412;
exports.TEMPLATE_NOT_EXIST = 431;
exports.FREQUENTLY_QR = 324; // The verification code is refreshed too frequently
exports.COMMON_ERR = 500; // general error
exports.MEMBER_NOT_EXIST = 508; // member does not exist
exports.BINDING_ACCOUNT_ERR = [320, 332];
// switch space, space is not activated
exports.INVALID_SPACE = 406;
// Email invitation, the inviter clicks the link, the space has been deleted, and the message is that the space does not exist
exports.SPACE_DELETED = 404;
// Public link invitation - the number of inviters in the space has reached the upper limit, temporarily unable to join
exports.INVITER_SPACE_MEMBER_LIMIT = 407;
// public link invite - invite link has expired
exports.LINK_INVALID = 517;
// public link invitation - the number of spaces has reached the limit
exports.SPACE_LIMIT = 405;
exports.NODE_DELETED = 600; // no permission or node is deleted
exports.NODE_NOT_EXIST = 601; // no permission or node doesn't exist
exports.NOT_PERMISSION = 602; // operation without permission - no editing permission
exports.PAYMENT_PLAN = 951;
exports.LOG_OUT_UNSATISFIED = 962; // The logout condition is not met, the user is not allowed to logout
// The datasheet for the magic form mapping does not exist
exports.FORM_DATASHEET_NOT_EXIST = 301;
exports.FORM_FOREIGN_DATASHEET_NOT_EXIST = 302;
// Front-end custom error code
exports.USER_DEFINED_PASSWORD_ERR = 1001;
exports.FEISHU_ACCOUNT_NOT_BOUND = 1110;
exports.WECOM_NOT_BIND_SPACE = 1106;
exports.DINGTALK_NOT_BIND_SPACE = 1106; // Enterprise unbound space
exports.DINGTALK_TENANT_NOT_EXIST = 1107; // tenant does not exist
exports.DINGTALK_USER_NOT_EXIST = 1109; // Tenant user is not authorized
exports.DINGTALK_USER_CONTACT_SYNCING = 1131; // Contacts are being synchronized
// Enterprise WeChat app store error code
exports.WECOM_SHOP_USER_NOT_EXIST = 1115; // The tenant is not visible to the application
// The exclusive domain name is not bound
exports.WECOM_NOT_BIND_DOMAIN = 1122;
exports.WECOM_HAS_BIND = 338; // The account has been bound to the corporate WeChat account
exports.WECOM_NO_EXIST = 1107; // The enterprise has not installed third-party applications
exports.WECOM_NO_INSTALL = 1114; // Enterprise application is deleted
exports.WECOM_OUT_OF_RANGE = 1109; // The tenant is not authorized, that is, the user is not within the visible range of the enterprise
exports.WECOM_NOT_ADMIN = 1113; // not an administrator
exports.SPACE_CAPACITY_OVER_LIMIT = 4008; // The space capacity exceeds the limit
exports.FRONT_VERSION_ERROR = 3005; //The front-end version does not match
exports.DELETE_ROLE_EXIST_MEMBER = 528; // Delete the role, but there are members in the role
var SmsErrCode;
(function (SmsErrCode) {
    SmsErrCode[SmsErrCode["GetErr"] = 230] = "GetErr";
    SmsErrCode[SmsErrCode["CheckErr"] = 231] = "CheckErr";
    SmsErrCode[SmsErrCode["CodeNotCheck"] = 232] = "CodeNotCheck";
    SmsErrCode[SmsErrCode["NormalErr"] = 500] = "NormalErr";
})(SmsErrCode = exports.SmsErrCode || (exports.SmsErrCode = {}));
var PhoneErr;
(function (PhoneErr) {
    PhoneErr[PhoneErr["CommonErr"] = 303] = "CommonErr";
    PhoneErr[PhoneErr["PhoneLengthErr"] = 500] = "PhoneLengthErr";
})(PhoneErr = exports.PhoneErr || (exports.PhoneErr = {}));
var AccountErr;
(function (AccountErr) {
    AccountErr[AccountErr["UserNameErr"] = 302] = "UserNameErr";
    AccountErr[AccountErr["CommonErr"] = 303] = "CommonErr";
    AccountErr[AccountErr["EmailErr"] = 304] = "EmailErr";
    AccountErr[AccountErr["PhoneLengthErr"] = 500] = "PhoneLengthErr";
})(AccountErr = exports.AccountErr || (exports.AccountErr = {}));
var PasswordErr;
(function (PasswordErr) {
    PasswordErr[PasswordErr["NameAndPwdErr"] = 302] = "NameAndPwdErr";
    PasswordErr[PasswordErr["PasswordEmptyErr"] = 305] = "PasswordEmptyErr";
})(PasswordErr = exports.PasswordErr || (exports.PasswordErr = {}));
//# sourceMappingURL=status_code.js.map